export default __webpack_public_path__ + "static/st-8785aede41b6d1ad908166874dec3e41.svg";